<div class="row">
    <div class="col-12 pt-3">
      <div class="row">
        <div class="col-12 p-0" *ngIf="isDataLoaded">
          <app-wizard-head [wizardInput]="wizardInput"></app-wizard-head>
        </div>
      </div>
    </div> 
      <div class="col-12 contentPortion p-0 page-header" *ngIf="isDataLoaded">
        <education-details-library [primaryData]="inputData" [isWizard]="true" style="width:100%"></education-details-library>
      </div>
</div>